import React, { PureComponent } from 'react';
import Modal from 'components/Modal/Modal';
import NewButton from 'components/Button/NewButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isPWA } from 'utils/helpers';
import MobileDetect from 'mobile-detect';
import { STORAGEKEY_SHOW_PWA_NOTIFICATION } from 'config/constants';
import LOGO from 'assets/logo-avatar.svg';
import CHROME_A from 'assets/chrome-pwa.svg';
import SAFARI_A from 'assets/safari-pwa-1.svg';
import SAFARI_B from 'assets/safari-pwa-2.svg';
import SAFARI_ICON from 'assets/safari-pwa-icon.png';
import './modal-notify-pwa.css';

const RENDER_TYPES = {
    CHROME: 1,
    SAFARI: 2
};

// see https://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser?rq=1
// see https://stackoverflow.com/questions/4565112/javascript-how-to-find-out-if-the-user-browser-is-chrome/13348618#13348618
function isChrome() {
    const userAgent = window.navigator.userAgent || '';
    const isOpera = typeof window.opr !== 'undefined';
    const isIEedge = userAgent.indexOf('Edge') > -1;

    if ((!!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime)) ||
        (window.navigator.vendor === 'Google Inc.' && isOpera === false && isIEedge === false) ||
        userAgent.match('CriOS')) {
        return true;
    }

    return false;
}

// see https://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser?rq=1
// see https://stackoverflow.com/questions/7944460/detect-safari-browser
function isSafari() {
    const userAgent = window.navigator.userAgent || '';
    const isSafari = window.navigator.vendor &&
        window.navigator.vendor.indexOf('Apple') > -1 &&
        userAgent.indexOf('CriOS') === -1 &&
        userAgent.indexOf('FxiOS') === -1;

    if (isSafari ||
        /constructor/i.test(window.HTMLElement) ||
        (function (p) { return p.toString() === '[object SafariRemoteNotification]'; })(!window.safari || (typeof window.safari !== 'undefined' && window.safari.pushNotification)) || // eslint-disable-line
        userAgent.indexOf('safari') > -1) {
        return true;
    }

    return false;
}


export default class ModalNotifyPwa extends PureComponent {
    constructor(props) {
        super(props);

        let renderType;

        if (!isPWA()) {
            if (isChrome()) {
                // Is Chrome browser
                renderType = RENDER_TYPES.CHROME;
            }
            else if (isSafari()) {
                // Is Safari browser
                renderType = RENDER_TYPES.SAFARI;
            }

            if (renderType) {
                if (!(new MobileDetect(window.navigator.userAgent).mobile())) {
                    renderType = null;
                }
                else {
                    let notifyCount = localStorage.getItem(STORAGEKEY_SHOW_PWA_NOTIFICATION);

                    if (!notifyCount) {
                        localStorage.setItem(STORAGEKEY_SHOW_PWA_NOTIFICATION, 1);
                    }
                    else {
                        notifyCount = JSON.parse(notifyCount);
                        notifyCount++;
                        localStorage.setItem(STORAGEKEY_SHOW_PWA_NOTIFICATION, notifyCount);

                        if (notifyCount % 2 !== 0) {
                            renderType = null;
                        }
                    }
                }
            }
        }

        this.state = {
            renderType,
            isRender: false
        };
    }

    componentDidMount() {
        const { renderType } = this.state;

        if (renderType) {
            setTimeout(this.toggleIsRender, 2500);
        }
    }

    toggleIsRender = () => {
        this.setState({ isRender: true });
    }

    onClose = () => {
        this.setState({ isRender: false });
    }

    renderContent = () => {
        const { renderType } = this.state;

        switch (renderType) {
            case RENDER_TYPES.CHROME:
                return (
                    <div className='modalnotifypwa__body-content modalnotifypwa__body-content--chrome'>
                        <img src={CHROME_A} alt='' />

                        <div className='modalnotifypwa__body-content-text modalnotifypwa__body-content-text--chrome'>
                            Sur Chrome : cliquez sur

                            <FontAwesomeIcon
                                className='modalnotifypwa__body-content-text-icon'
                                icon='ellipsis-v' />

                            puis sur "Ajouter à l'écran d'accueil"
                        </div>
                    </div>
                );

            case RENDER_TYPES.SAFARI:
                return (
                    <div className='modalnotifypwa__body-content modalnotifypwa__body-content--safari'>
                        <img src={SAFARI_A} alt='' />

                        <div className='modalnotifypwa__body-content-text modalnotifypwa__body-content-text--safari'>
                            Safari : cliquez en bas sur

                            <img
                                className='modalnotifypwa__body-content-text-icon'
                                src={SAFARI_ICON}
                                alt='' />

                            puis glissez le menu vers le haut pour trouver :
                        </div>

                        <img src={SAFARI_B} alt='' />
                    </div>
                );

            default:
                return null;
        }
    }

    render() {
        const { isRender } = this.state;

        if (!isRender) {
            return null;
        }

        return (
            <Modal
                isVisible={true}
                isCloseButton={false}
                dialogClassName='modalnotifypwa-modal'>
                <div className='modalnotifypwa'>
                    <div className='modalnotifypwa__header'>
                        <div className='modalnotifypwa__title'>
                            UTILISEZ NOTRE VERSION MOBILE !
                        </div>

                        <div className='flex-row flex-ac'>
                            <img
                                className='modalnotifypwa__logo'
                                src={LOGO}
                                alt='Factio.org logo' />

                            <div className='modalnotifypwa__subtitle'>
                                Accès en un clic via l'icone Connexion automatique Notifications
                            </div>
                        </div>
                    </div>

                    <div className='modalnotifypwa__body'>
                        {this.renderContent()}
                    </div>

                    <div className='modalnotifypwa__footer'>
                        <NewButton
                            className='modalnotifypwa__footer-button'
                            onClick={this.onClose}>
                            Poursuivre sans en profiter

                            <FontAwesomeIcon
                                className='modalnotifypwa__footer-button-icon'
                                icon='times' />
                        </NewButton>
                    </div>
                </div>
            </Modal>
        );
    }
}
